
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetObjArr } from "@/utils/base";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any; // 全部数据
  @Prop()
  private currentData: any; // 父组件里面传入的数据，需要在右侧选中
  @Prop()
  private visible: any;
  @Watch("visible", { immediate: true })
  private visibleChange() {
    this.ifLiangbiao = this.visible;
    if (this.visible) {
      this.getData();
    }
  }
  private ifLiangbiao: any = false;
  private leftCheckedAll: any = false;
  private rightCheckedAll: any = false;
  private leftData: any = [];
  private rightData: any = [];
  // private data: any = [];
  private openSave() {
    const arr: any = GetObjArr(this.rightData, "hide", false);
    this.$emit("change", arr);
  }
  private cancel() {
    this.$emit("cancel");
  }
  private isShowTitle(items: any) {
    let result = false;
    if (items) {
      items.forEach((ele: any) => {
        if (!ele.hide) {
          result = true;
        }
      });
    }
    return result;
  }
  private getCheckedNum(item: any) {
    let num = 0;
    item.forEach((ele: any) => {
      if (!ele.hide && ele.checked) {
        num++;
      }
    });
    return num;
  }
  private leftSelAll() {
    if (this.leftCheckedAll) {
      // 选中全部
      this.leftData.forEach((ele: any) => {
        if (!ele.hide) {
          ele.checked = true;
        }
      });
      this.$forceUpdate();
    } else {
      // 取消全部选择
      this.leftData.forEach((ele: any) => {
        ele.checked = false;
      });
      this.$forceUpdate();
    }
  }
  private rightSelAll() {
    if (this.rightCheckedAll) {
      // 选中全部
      this.rightData.forEach((ele: any) => {
        if (!ele.hide && !ele.disabled) {
          ele.checked = true;
        }
      });
    } else {
      // 取消全部选择
      this.rightData.forEach((ele: any) => {
        ele.checked = false;
      });
    }
  }
  private toLeft() {
    this.rightData.forEach((ele: any) => {
      this.leftData.forEach((e: any) => {
        if (ele.id === e.id && !ele.hide && ele.checked) {
          // 改变左边数据
          e.checked = false;
          e.hide = false;
          // 改变右边数据
          ele.hide = true;
          ele.checked = false;
        }
      });
    });
    // 清除左边选中的
    this.leftCheckedAll = false;
    this.rightCheckedAll = false;
    this.$forceUpdate();
  }
  private toRight() {
    this.leftData.forEach((ele: any) => {
      this.rightData.forEach((e: any) => {
        if (ele.id === e.id && !ele.hide && ele.checked) {
          // 改变右边数据
          e.checked = false;
          e.hide = false;
          // 改变左边数据
          ele.hide = true;
          ele.checked = false;
        }
      });
    });
    // 清除左边选中的
    this.leftCheckedAll = false;
    this.rightCheckedAll = false;
    this.$forceUpdate();
  }
  private getData() {
    console.log("处理数据");
    console.log(this.data);
    this.data.forEach((ele: any) => {
      ele.checked = false;
    });
    this.leftData = JSON.parse(JSON.stringify(this.data));
    this.rightData = JSON.parse(JSON.stringify(this.data));
    // 处理左边
    this.leftData.forEach((ele: any) => {
      const i = this.currentData.findIndex((val: any) => {
        return ele.id === val.id;
      });
      if (i != -1) {
        ele.hide = true;
      } else {
        ele.hide = false;
      }
    });
    // 处理右边
    this.rightData.forEach((ele: any) => {
      const i = this.currentData.findIndex((val: any) => {
        return ele.id === val.id;
      });
      if (i != -1) {
        ele.hide = false;
        // ele.checked = true;
        // ele.disabled = true;
      } else {
        ele.hide = true;
      }
    });
  }
  private mounted() {
    this.ifLiangbiao = this.visible;
  }
}
